import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  name: 'JTreeTable',
  props: {
    rowKey: {
      type: String,
      default: 'id'
    },
    // 根据什么查询，如果传递 id 就根据 id 查询
    queryKey: {
      type: String,
      default: 'parentId'
    },
    queryParams: {
      type: Object,
      default: function _default() {}
    },
    // 查询顶级时的值，如果顶级为0，则传0
    topValue: {
      type: String,
      default: null
    },
    columns: {
      type: Array,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    childrenUrl: {
      type: String,
      default: null
    },
    tableProps: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      dataSource: []
    };
  },
  computed: {
    getChildrenUrl: function getChildrenUrl() {
      if (this.childrenUrl) {
        return this.childrenUrl;
      } else {
        return this.url;
      }
    },
    slots: function slots() {
      var slots = [];

      var _iterator = _createForOfIteratorHelper(this.columns),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var column = _step.value;

          if (column.scopedSlots && column.scopedSlots.customRender) {
            slots.push(column.scopedSlots.customRender);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return slots;
    }
  },
  watch: {
    queryParams: {
      deep: true,
      handler: function handler() {
        this.loadData();
      }
    }
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    /** 加载数据*/
    loadData: function loadData() {
      var _this = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.topValue;
      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.url;
      var params = Object.assign({}, this.queryParams || {});
      params[this.queryKey] = id;
      return getAction(url, params).then(function (res) {
        var dataSource = res.result.map(function (item) {
          // 判断是否标记了带有子级
          if (item.hasChildren === true) {
            // 定义默认展开时显示的loading子级，实际子级数据只在展开时加载
            var loadChild = {
              id: "".concat(item.id, "_loadChild"),
              name: 'loading...',
              isLoading: true
            };
            item.children = [loadChild];
          }

          return item;
        });

        if (first) {
          _this.dataSource = dataSource;
        }

        return Promise.resolve(dataSource);
      });
    },

    /** 点击展开图标时触发 */
    handleExpand: function handleExpand(expanded, record) {
      // 判断是否是展开状态
      if (expanded) {
        // 判断子级的首个项的标记是否是“正在加载中”，如果是就加载数据
        if (record.children[0].isLoading === true) {
          this.loadData(record.id, false, this.getChildrenUrl).then(function (dataSource) {
            // 处理好的数据可直接赋值给children
            if (dataSource.length === 0) {
              record.children = null;
            } else {
              record.children = dataSource;
            }
          });
        }
      }
    }
  }
};